import { getAdminCommunities } from "@queries/user.queries";
import { Store } from "@store";
import styles from "@styles/profile/joinedCommunitiesTab.module.css";
import { viewCommunityProfile } from "@utils/viewPage";
import axios from "axios";
import { useRouter } from "next/router";
import { useContext, useEffect, useRef, useState } from "react";
import CommunityProfileItem from "@components/general/CommunityProfileItem";
import LoadingCircle from "@components/loadings/LoadingCircle";
import InfiniteScroll from "react-infinite-scroll-component";
export default function ManagedCommunitiesTab() {
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const router = useRouter();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const REF = useRef(null);
  useEffect(() => {
    async function getData(token) {
      const response = await getAdminCommunities({
        accessToken: loggedInUser.accessToken,
        cancelToken: token
      });
      if (response) {
        setData(response);
      } else {
        setData([]);
      }
      setIsLoading(false);
    }
    let source = null;
    if (loggedInUser.authType) {
      source = axios.CancelToken.source();
      getData(source.token);
    }
    return () => {
      if (source) source.cancel();
    };
  }, [loggedInUser]);

  //   useEffect(() => {
  //     if (typeof window !== "undefined" && REF.current && !isLoading) {
  //       if (REF.current.clientHeight <= window.innerHeight && data.length <= 10) {
  //         updateCommunityData();
  //       }
  //     }

  //     // eslint-disable-next-line
  //   }, [REF, isLoading]);

  //   async function updateCommunityData() {
  //     let ts = null;
  //     if (data?.length > 0) ts = data[data.length - 1].joiningTime;
  //     else return () => {};

  //     const res = await getAdminCommunities({
  //       accessToken: loggedInUser.accessToken,
  //     });

  //     if (res?.length === 0) {
  //       setHasMore(false);
  //     } else setData((cur) => cur.concat(res));
  //   }

  function renderCommunity(item, index) {
    return <div key={index.toString()} data-sentry-component="renderCommunity" data-sentry-source-file="ManagedCommunitiesTab.jsx">
        <CommunityProfileItem data={item} onClickHandler={() => viewCommunityProfile(item.urlExtension, router)} data-sentry-element="CommunityProfileItem" data-sentry-source-file="ManagedCommunitiesTab.jsx" />
        <hr className={styles.managedCommunititesHr} />
      </div>;
  }
  if (isLoading) {
    return <p className={styles.loadingText}>Loading...</p>;
  } else {
    return <>
        {data?.length > 0 && <div>
            <div className={styles.community_list_container} ref={REF}>
              <InfiniteScroll dataLength={data.length}
          // next={updateCommunityData}
          hasMore={hasMore} loader={<LoadingCircle />}>
                {data.map(renderCommunity)}
              </InfiniteScroll>
            </div>
          </div>}
      </>;
  }
}